
// ORIGNAL LIGHT
const LIGHT_CONTRAST_1 = [
    'FAFBFC',
    'FAFBFC',
    'FAFBFC',
    'F7F8FA',
    'ECEFF3',
    'ECEFF3',
    'E6EBEF',
    'DADDE1',
    'CDD2D7',
    '7E8B98',
    '58697A',
    '4E5D6B',
]
const LIGHT_CONTRAST_2 = [
    'F8F9FA',
    'F8F9FA',
    'F8F9FA',
    'F4F5F7',
    'E9ECF0',
    'E9ECF0',
    'E4E9ED',
    'D7DADE',
    'CACFD4',
    '7E8B98',
    '58697A',
    '4E5D6B',
]

// ORIGINAL CONTRAST !
const LIGHT_CONTRAST_3 = [
    'F5F6F7',
    'F5F6F7',
    'F5F6F7',
    'F2F4F5',
    'E6EAED',
    'E6EAED',
    'E2E6EB',
    'D3D7DB',
    'C5CBD1',
    '7E8B98',
    '58697A',
    '4E5D6B',
]

// MORE CONTRAST
const LIGHT_CONTRAST_4 = [
    'F3F4F5',
    'F3F4F5',
    'F3F4F5',
    'F0F1F2',
    'E4E8EB',
    'E4E7EB',
    'DFE3E8',
    'D0D4D9',
    'C0C6CF',
    '7E8B98',
    '58697A',
    '4E5D6B',
]

// MORE CONTRAST
const LIGHT_CONTRAST_5 = [
    'F0F2F5',
    'F0F2F5',
    'F0F2F5',
    'EBEEF2',
    'E0E5EB',
    'DEE3E8',
    'DBE0E5',
    'CFD1D6',
    'BAC2C9',
    '7E8B98',
    '58697A',
    '4E5D6B',
]

// This is dark blue
const DARK_CONTRAST_1 = [
    '1A222C',   // palette-gray-0
    '1C2631',   // palette-gray-1
    '1C2631',   // palette-gray-2
    '212A35',   // palette-gray-3
    '27313B',   // palette-gray-4
    '3C434C',   // palette-gray-5
    '484E56',   // palette-gray-6
    '535961',   // palette-gray-7
    '5F646B',   // palette-gray-8
    '7E8B98',   // palette-gray-9
    '9A9FA3',   // palette-gray-10
    'ABAFB3'    // palette-gray-11
]

// This is Black (telegram) theme
const DARK_CONTRAST_2 = [
    '1A232B',   // palette-gray-0 1E272E
    '1A232B',   // palette-gray-1 1E272E
    '1E2831',   // palette-gray-2 1E272E
    '232C35',   // palette-gray-3 252E36
    '2E353C',   // palette-gray-4 313940
    '3A4147',   // palette-gray-5 3C444B
    '454C51',   // palette-gray-6 484F55
    '51575C',   // palette-gray-7 535A60
    '5D6267',   // palette-gray-8 5F656B
    '7E8B98',   // palette-gray-9 6A7075
    '9A9FA3',   // palette-gray-10 9A9FA3
    'ABAFB3'    // palette-gray-11 ABAFB3
]

const PALETTES: any = {
    'light-1'   : LIGHT_CONTRAST_1,
    'light-2'   : LIGHT_CONTRAST_2,
    'light-3'   : LIGHT_CONTRAST_3,
    'light-4'   : LIGHT_CONTRAST_4,
    'light-5'   : LIGHT_CONTRAST_5,
    'dark-1'    : DARK_CONTRAST_1,
    'dark-2'    : DARK_CONTRAST_2,
}

const DEFAULT_PALETTE = 'light-1'


const debug = false
// const debug = "GrayPalette"

export default class GrayPalette {

    public currentPalette   : string
    public isDarkMode       : boolean

    constructor(currentPalette= DEFAULT_PALETTE) {

        this.currentPalette = DEFAULT_PALETTE;
        this.isDarkMode     = false;

        this.setPalette(currentPalette)

        debug && console.log(debug, 'constructor', PALETTES[this.currentPalette])
    }

    setPalette(palette:string) {
        if (palette===this.currentPalette) return;

        // make sure palette exists
        // @ts-ignore
        if (!PALETTES[palette]) palette = DEFAULT_PALETTE

        this.currentPalette = palette;
        this.applyDOMCssVariables();
    }

    applyDOMCssVariables() {
        // @ts-ignore
        const palette = PALETTES[this.currentPalette]
        const root = document.querySelector(':root');

        for (let i=0; i<=11; i++) {
            // @ts-ignore
            root.style.setProperty('--palette-gray-'+i, '#'+palette[i])
        }
    }

    lightPalettes() {
        return [
            'light-1',
            'light-2',
            'light-3',
            'light-4',
            'light-5',
        ]
    }

    getColorHEX(index:number) {
        // @ts-ignore
        return PALETTES[this.currentPalette] ? '#{0}'.f(PALETTES[this.currentPalette][index]) : '#000000'
    }

    // darkPalettes() {
    //     return [
    //         'dark-1',
    //         'dark-2'
    //     ]
    // }
}
